import { render, staticRenderFns } from "./withdrawRecord.vue?vue&type=template&id=1ed33166&scoped=true&"
import script from "./withdrawRecord.vue?vue&type=script&lang=ts&"
export * from "./withdrawRecord.vue?vue&type=script&lang=ts&"
import style0 from "./withdrawRecord.vue?vue&type=style&index=0&id=1ed33166&lang=less&scoped=true&"
import style1 from "./withdrawRecord.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed33166",
  null
  
)

export default component.exports